import payablesList from './payables/list';
import addInvoice from './payables/add';
import paymentApplyList from './payment/list';
import paymentApplyAdd from './payment/add';
import paymentAdd from './payment/paymentAdd';
import paymentList from './payment/paymentList';
import saleInvoiceZh from './saleInvoice/zh';
import bankAccountList from './bankAccount/list';
import bankAccountEdit from './bankAccount/edit';
import withholding from './withholding/list';
import bankDirectFlow from './payment/bankDirectFlow';

import matchPurchaseContract from './payables/matchPurchaseContract';
import currenciesAndCalendar from './GeneralAccounting/currenciesAndCalendar';
import exchangerate from './GeneralAccounting/exchangerate';
export default {
  ...payablesList,
  ...addInvoice,
  ...matchPurchaseContract,
  ...currenciesAndCalendar,
  ...exchangerate,
  ...paymentAdd,
  ...paymentList,
  ...paymentApplyList,
  ...paymentApplyAdd,
  ...saleInvoiceZh,
  ...bankAccountList,
  ...bankAccountEdit,
  ...withholding,
  ...bankDirectFlow,
};
